import { createActionConst } from '../../../utils/action.utils';

const MEETING_SHORTCUT_NAMESPACE = 'MEETING_SHORTCUT';

export const STORE_MEETING_SHORTCUT = createActionConst(MEETING_SHORTCUT_NAMESPACE, 'STORE_MEETING_SHORTCUT');
export const CLEAR_MEETING_SHORTCUT = createActionConst(MEETING_SHORTCUT_NAMESPACE, 'CLEAR_MEETING_SHORTCUT');

export const STORE_MEETING_SHORTCUTS_FOLDER = createActionConst(
  MEETING_SHORTCUT_NAMESPACE,
  'STORE_MEETING_SHORTCUTS_FOLDER',
);
export const CLEAR_MEETING_SHORTCUTS_FOLDER = createActionConst(
  MEETING_SHORTCUT_NAMESPACE,
  'CLEAR_MEETING_SHORTCUTS_FOLDER',
);
